import { render, staticRenderFns } from "./VFatherPatRecord.vue?vue&type=template&id=1fdc156e"
import script from "./VFatherPatRecord.vue?vue&type=script&lang=js"
export * from "./VFatherPatRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports